import type { Session } from '@supabase/supabase-js';
import { useEffect, useState } from 'react';
import { supabase } from './supabase.js';

export interface AuthState {
  session: Session | null;
  loading: boolean;
  /** Voltou pelo link de "esqueci a senha": o app pede a senha nova antes de seguir. */
  recuperandoSenha: boolean;
  terminarRecuperacao: () => void;
}

/**
 * Sessao do Supabase.
 *
 * A sessao e lida do armazenamento local antes de qualquer chamada de rede —
 * o app precisa abrir e funcionar no modo aviao, com a equipe ja no haras.
 */
export function useAuth(): AuthState {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);
  const [recuperandoSenha, setRecuperandoSenha] = useState(false);

  useEffect(() => {
    let vivo = true;

    supabase.auth.getSession().then(({ data }) => {
      if (!vivo) return;
      setSession(data.session);
      setLoading(false);
    });

    const { data: sub } = supabase.auth.onAuthStateChange((evento, s) => {
      if (!vivo) return;
      setSession(s);
      if (evento === 'PASSWORD_RECOVERY') setRecuperandoSenha(true);
    });

    return () => {
      vivo = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  return { session, loading, recuperandoSenha, terminarRecuperacao: () => setRecuperandoSenha(false) };
}
